// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip-module__root___pJsfD","arrow--hide":"Tooltip-module__arrow--hide___A9Ok+","arrow":"Tooltip-module__arrow___MZRzN"};